import React from "react";
import styled, { css } from "styled-components";
var CoinsSvg = function CoinsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    opacity: ".5",
    clipPath: "url(#a)",
    stroke: "#000",
    strokeWidth: "1.16",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.105 22.62s1.085.513 1.906-.91c.593-1.026.287-1.842-.403-2.24-.81-.468-1.514-.172-2.36.646-.846.818-1.538 1.12-2.349.654-.69-.399-1.006-1.223-.414-2.25.82-1.422 1.905-.908 1.905-.908M5.23 17.796l1.256.725M13.268 22.436l-1.255-.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.027 24.031c1.361-2.358-.571-6.022-4.316-8.184-3.745-2.162-7.885-2.004-9.246.354-1.361 2.358.571 6.023 4.316 8.185 3.745 2.162 7.885 2.003 9.246-.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.466 16.201-1.45 2.512c-1.361 2.357.571 6.021 4.317 8.183 3.745 2.162 7.885 2.004 9.246-.353l1.45-2.512"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.922 14.062c2.605-2.604 3.431-6.001 1.845-7.587-1.585-1.585-4.982-.76-7.587 1.846-2.604 2.604-3.43 6.001-1.845 7.587 1.585 1.586 4.982.76 7.587-1.846Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.335 15.908 1.846 1.846c1.585 1.585 4.982.76 7.588-1.846 2.605-2.605 3.43-6.001 1.846-7.588l-1.846-1.845",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.231 11.063s.635-.75-.334-1.717c-.698-.699-1.407-.642-1.868-.181-.541.54-.456 1.173.024 2.027.48.854.557 1.494.016 2.034-.461.461-1.163.51-1.862-.188-.967-.967-.333-1.717-.333-1.717",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.387 13.857.82-.819M22.9 9.346l.82-.82",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.246 9.946c1.665-.961 1.846-3.764.404-6.26C12.21 1.187 9.69-.057 8.026.904c-1.664.96-1.845 3.763-.403 6.26 1.441 2.497 3.959 3.742 5.623 2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.026.903-2.01 1.16c-1.664.962-1.845 3.765-.402 6.261 1.442 2.497 3.96 3.741 5.623 2.781l2.01-1.16"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h29v29H0z"
  }))));
};
CoinsSvg.defaultProps = {
  width: "29",
  height: "26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
export var RadioBoxContainer = styled.div.withConfig({
  componentId: "sc-aolpyi-0"
})(function (_ref) {
  var $isChecked = _ref.$isChecked,
    theme = _ref.theme;
  return css(["border-radius:", ";position:relative;overflow:hidden;box-shadow:", ";margin-bottom:", ";&:hover:after{box-shadow:", ";}", " ", "{margin-bottom:", ";}"], getBorderRadius(theme, "mlarge"), getBoxShadow(theme, "nano"), space(2), getBoxShadow(theme, "tiny"), $isChecked ? css(["box-shadow:", ";&:after{content:\"\";position:absolute;left:0;right:0;top:0;bottom:0;border:", " solid ", ";border-radius:", ";cursor:pointer;}"], getBoxShadow(theme, "small"), unit(2), getColor(theme, "backgroundBlack"), getBorderRadius(theme, "mlarge")) : null, breakpoint("medium"), space(1.5));
});
export var InnerContainer = styled(FlexContainerOrg).withConfig({
  componentId: "sc-aolpyi-1"
})(function () {
  return css(["padding:", " ", " ", " ", ";", "{flex-direction:column;align-items:space-between;}"], space(2), space(3), space(2), space(4), breakpoint("small", "medium"));
});
export var RadioButtonContainer = styled(FlexContainerOrg).withConfig({
  componentId: "sc-aolpyi-2"
})(function () {
  return css(["align-items:center;", "{justify-content:flex-start;}"], breakpoint("small", "medium"));
});
export var AsideContainer = styled(FlexItemOrg).withConfig({
  componentId: "sc-aolpyi-3"
})(function () {
  return css(["cursor:pointer;", "{width:100%;padding-left:", ";}"], breakpoint("small", "medium"), space(4));
});
export var FlexContainer = styled(FlexItemOrg).withConfig({
  componentId: "sc-aolpyi-4"
})(function (_ref2) {
  var $hasBottomLabel = _ref2.$hasBottomLabel;
  return css(["", "{display:flex;width:100%;justify-content:space-between;", "}"], breakpoint("small", "medium"), $hasBottomLabel ? css(["flex-direction:row-reverse;"]) : null);
});
export var TopLabelContainer = styled.div.withConfig({
  componentId: "sc-aolpyi-5"
})(function (_ref3) {
  var $topLabelBackgroundColor = _ref3.$topLabelBackgroundColor,
    theme = _ref3.theme;
  return css(["display:flex;border-radius:", " ", " 0 0;position:relative;width:auto;align-items:center;justify-content:space-between;gap:", ";padding:", " ", " ", " ", ";background-color:", ";", "{justify-content:flex-start;border-radius:", " 0 ", ";width:fit-content;}"], getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge"), space(0.5), space(0.5), space(1.5), space(0.5), space(6), getColor(theme, $topLabelBackgroundColor), breakpoint("medium"), getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge"));
});
export var CoinsIcon = styled(CoinsSvg).withConfig({
  componentId: "sc-aolpyi-6"
})(function (_ref4) {
  var $onColor = _ref4.$onColor,
    theme = _ref4.theme;
  return css(["position:absolute;bottom:0;left:", ";path{stroke:", ";}"], unit(8), getTextColor(theme, $onColor));
});